<template>
  <div
    class="bg-card rounded-[16px] p-6 border border-border relative overflow-hidden"
  >
    <div
      v-if="watermark"
      class="absolute inset-0 bg-background/80 backdrop-blur-[2px] flex items-center justify-center z-10 pointer-events-none"
    >
      <div
        class="text-[48px] font-bold text-foreground/10 transform -rotate-12 whitespace-nowrap"
      >
        COMING SOON
      </div>
    </div>

    <h2 class="text-[14px] font-semibold text-foreground">About</h2>

    <div
      class="flex items-start gap-3 mt-5"
      :class="{ 'opacity-40': watermark }"
    >
      <img
        :src="userAvatar"
        alt="User"
        class="w-12 h-12 rounded-[10px] object-cover"
      />
      <div class="min-w-0">
        <p class="text-[14px] font-semibold text-foreground truncate">
          {{ userName }}
        </p>
        <p class="text-[12px] text-muted-foreground mt-0.5">
          Aspiring Product Designer
        </p>
      </div>
    </div>

    <div
      class="mt-5 border-t border-border pt-4 space-y-3 text-[12px]"
      :class="{ 'opacity-40': watermark }"
    >
      <div class="flex items-center justify-between">
        <span class="text-muted-foreground">Primary talent group</span>
        <span
          class="px-2.5 py-1 rounded-full text-[11px] border border-[#F79009] text-[#F79009] bg-[#FFFAEB]"
        >
          Design
        </span>
      </div>

      <div class="flex items-center justify-between">
        <span class="text-muted-foreground">Date joined</span>
        <span class="text-foreground">{{ dateJoined }}</span>
      </div>
    </div>

    <div
      class="mt-5 pt-4 border-t border-border"
      :class="{ 'opacity-40': watermark }"
    >
      <h4 class="text-[13px] font-semibold text-foreground">Goals in common</h4>
      <div
        class="flex items-center gap-2 mt-3 text-[12px] text-muted-foreground"
      >
        <span class="w-2 h-2 rounded-full bg-muted-foreground"></span>
        <span class="truncate">Product Design Fundamentals &amp; 1 other</span>
      </div>
    </div>

    <div
      class="mt-5 pt-4 border-t border-border"
      :class="{ 'opacity-40': watermark }"
    >
      <h4 class="text-[13px] font-semibold text-foreground">
        People To Follow
      </h4>
      <div class="space-y-4 mt-4">
        <div
          v-for="person in peopleToFollow"
          :key="person.id"
          class="flex items-center justify-between gap-3"
        >
          <div class="flex items-center gap-2 min-w-0">
            <img
              :src="person.avatar"
              alt="User"
              class="w-10 h-10 rounded-[10px] object-cover"
            />
            <div class="min-w-0">
              <p class="text-[12px] font-semibold text-foreground truncate">
                {{ person.name }}
              </p>
              <p class="text-[11px] text-muted-foreground truncate">
                Aspiring Product Designer
              </p>
            </div>
          </div>
          <button
            type="button"
            class="px-4 py-1.5 bg-primary text-primary-foreground text-[11px] rounded-full hover:bg-primary/90 transition-colors"
          >
            Follow
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutCard",
  props: {
    userAvatar: { type: String, required: true },
    userName: { type: String, required: true },
    dateJoined: { type: String, default: "" },
    peopleToFollow: { type: Array, default: () => [] },
    watermark: { type: Boolean, default: false },
  },
};
</script>
